function calculatePercentage(a: number, b: number): number {
	return Math.round(100 * (a / b));
}

export default calculatePercentage;
